import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';

export const sendCertificateEnabledEvent = (isToggleOn) => {
  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      category: EVENTS_CATEGORY.CERTIFICATE.ENABLE_CERTIFICATE,
      action: isToggleOn
        ? EVENTS_INTERACTIONS.TOGGLE_ON
        : EVENTS_INTERACTIONS.TOGGLE_OFF
    })
  });
};
